// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var URLUtils$SmartcutsMacros = require("../../../bs-utils/src/URLUtils.bs.js");
var Exceptions$SmartcutsMacros = require("../Exceptions.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var SmartcutIds$SmartcutsMacros = require("../SmartcutIds.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var UrlConstraint$SmartcutsMacros = require("../UrlConstraint.bs.js");
var MultiUrlTriggering__Types$SmartcutsMacros = require("../app/MultiUrlTriggering/MultiUrlTriggering__Types.bs.js");
var MultiUrlTriggering__LinkGroup$SmartcutsMacros = require("../app/MultiUrlTriggering/MultiUrlTriggering__LinkGroup.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "paginateFn",
                MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_encode(v.paginateFn)
              ],
              [
                "pageUntil",
                MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_encode(v.pageUntil)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var paginateFn = MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateFn"), null));
  if (paginateFn.TAG === /* Ok */0) {
    var pageUntil = MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageUntil"), null));
    if (pageUntil.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                paginateFn: paginateFn._0,
                pageUntil: pageUntil._0
              }
            };
    }
    var e = pageUntil._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".pageUntil" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = paginateFn._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".paginateFn" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function selectorGet(param) {
  return MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.selectorGet(param.paginateFn);
}

function mapSelector(f, paginate) {
  var func = MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.mapSelector;
  return {
          paginateFn: Curry._2(func, f, paginate.paginateFn),
          pageUntil: paginate.pageUntil
        };
}

function stringify(param) {
  return "{ paginateFn: " + (MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.stringify(param.paginateFn) + (", pageUntil: " + (MultiUrlTriggering__Types$SmartcutsMacros.stringifyPageUntil(param.pageUntil) + " }")));
}

var Paginate = {
  t_encode: t_encode,
  t_decode: t_decode,
  selectorGet: selectorGet,
  mapSelector: mapSelector,
  stringify: stringify
};

function topologyAlgoResult_encode(v) {
  return [
          "TopologyAlgoResultV1",
          Decco.arrayToJson(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_encode, v._0)
        ];
}

function topologyAlgoResult_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "TopologyAlgoResultV1") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.arrayFromJson(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* TopologyAlgoResultV1 */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "smartcutName",
                Decco.stringToJson(v.smartcutName)
              ],
              [
                "paginate",
                Decco.optionToJson(t_encode, v.paginate)
              ],
              [
                "topologyResult",
                topologyAlgoResult_encode(v.topologyResult)
              ],
              [
                "smartcutUrlPattern",
                Decco.optionToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, v.smartcutUrlPattern)
              ],
              [
                "maybeRedirectedFromUrlPatterns",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, param);
                      }), v.maybeRedirectedFromUrlPatterns)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
  if (url.TAG === /* Ok */0) {
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */0) {
      var smartcutName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutName"), null));
      if (smartcutName.TAG === /* Ok */0) {
        var paginate = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginate"), null));
        if (paginate.TAG === /* Ok */0) {
          var topologyResult = topologyAlgoResult_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "topologyResult"), null));
          if (topologyResult.TAG === /* Ok */0) {
            var smartcutUrlPattern = Decco.optionFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutUrlPattern"), null));
            if (smartcutUrlPattern.TAG === /* Ok */0) {
              var maybeRedirectedFromUrlPatterns = Decco.optionFromJson((function (param) {
                      return Decco.arrayFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, param);
                    }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeRedirectedFromUrlPatterns"), null));
              if (maybeRedirectedFromUrlPatterns.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          url: url._0,
                          smartcutId: smartcutId._0,
                          smartcutName: smartcutName._0,
                          paginate: paginate._0,
                          topologyResult: topologyResult._0,
                          smartcutUrlPattern: smartcutUrlPattern._0,
                          maybeRedirectedFromUrlPatterns: maybeRedirectedFromUrlPatterns._0
                        }
                      };
              }
              var e = maybeRedirectedFromUrlPatterns._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".maybeRedirectedFromUrlPatterns" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = smartcutUrlPattern._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".smartcutUrlPattern" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = topologyResult._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".topologyResult" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = paginate._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".paginate" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = smartcutName._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".smartcutName" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = smartcutId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".smartcutId" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".url" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function stringify$1(param) {
  return "{ url: " + (param.url + (", smartcutId: " + (param.smartcutId + (", smartcutName: " + (param.smartcutName + (", paginate: " + (OptionUtils$SmartcutsMacros.stringify(stringify, param.paginate) + " }")))))));
}

function smartcutIdGet(param) {
  return param.smartcutId;
}

function selectorGet$1(param) {
  return OptionUtils$SmartcutsMacros.toArray(Belt_Option.flatMap(param.paginate, selectorGet));
}

function mapSelector$1(f, commandValue) {
  return {
          url: commandValue.url,
          smartcutId: commandValue.smartcutId,
          smartcutName: commandValue.smartcutName,
          paginate: Belt_Option.map(commandValue.paginate, (function (param) {
                  return mapSelector(f, param);
                })),
          topologyResult: commandValue.topologyResult,
          smartcutUrlPattern: commandValue.smartcutUrlPattern,
          maybeRedirectedFromUrlPatterns: commandValue.maybeRedirectedFromUrlPatterns
        };
}

function getIdentifier(param) {
  return "Loop(" + param.smartcutId + ")(" + param.url + ")";
}

var CommandValue = {
  Paginate: Paginate,
  topologyAlgoResult_encode: topologyAlgoResult_encode,
  topologyAlgoResult_decode: topologyAlgoResult_decode,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1,
  smartcutIdGet: smartcutIdGet,
  selectorGet: selectorGet$1,
  mapSelector: mapSelector$1,
  getIdentifier: getIdentifier
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "originalUrl",
                Decco.stringToJson(v.originalUrl)
              ],
              [
                "paginate",
                Decco.optionToJson(t_encode, v.paginate)
              ],
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var originalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalUrl"), null));
  if (originalUrl.TAG === /* Ok */0) {
    var paginate = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginate"), null));
    if (paginate.TAG === /* Ok */0) {
      var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
      if (smartcutId.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  originalUrl: originalUrl._0,
                  paginate: paginate._0,
                  smartcutId: smartcutId._0
                }
              };
      }
      var e = smartcutId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".smartcutId" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = paginate._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".paginate" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = originalUrl._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".originalUrl" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$2(param) {
  return "{ originalUrl: " + (param.originalUrl + (", smartcutId: " + (param.smartcutId + " }")));
}

function updateConfigWithPlaybackFormLabel(param, config) {
  return config;
}

function isDynamic(param) {
  return true;
}

function fromCommandValue(param) {
  return {
          originalUrl: param.url,
          paginate: param.paginate,
          smartcutId: param.smartcutId
        };
}

var AuthoringConfig = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2,
  updateConfigWithPlaybackFormLabel: updateConfigWithPlaybackFormLabel,
  isDynamic: isDynamic,
  fromCommandValue: fromCommandValue
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "originalUrl",
                Decco.stringToJson(v.originalUrl)
              ],
              [
                "maybePageUntil",
                Decco.optionToJson(MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_encode, v.maybePageUntil)
              ],
              [
                "urlPattern",
                UrlConstraint$SmartcutsMacros.UrlPattern.t_encode(v.urlPattern)
              ],
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var originalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalUrl"), null));
  if (originalUrl.TAG === /* Ok */0) {
    var maybePageUntil = Decco.optionFromJson(MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybePageUntil"), null));
    if (maybePageUntil.TAG === /* Ok */0) {
      var urlPattern = UrlConstraint$SmartcutsMacros.UrlPattern.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlPattern"), null));
      if (urlPattern.TAG === /* Ok */0) {
        var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
        if (smartcutId.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    originalUrl: originalUrl._0,
                    maybePageUntil: maybePageUntil._0,
                    urlPattern: urlPattern._0,
                    smartcutId: smartcutId._0
                  }
                };
        }
        var e = smartcutId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".smartcutId" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = urlPattern._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".urlPattern" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = maybePageUntil._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".maybePageUntil" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = originalUrl._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".originalUrl" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify$3(param) {
  return "{ originalUrl: " + (StringUtils$SmartcutsMacros.quote(param.originalUrl) + (", maybePageUntil: " + (OptionUtils$SmartcutsMacros.stringify(MultiUrlTriggering__Types$SmartcutsMacros.stringifyPageUntil, param.maybePageUntil) + (", smartcutId: " + param.smartcutId))));
}

function fromAuthoringConfig(param) {
  var originalUrl = param.originalUrl;
  var url = URLUtils$SmartcutsMacros.$$URL.fromString(originalUrl);
  var urlPattern;
  if (url !== undefined) {
    urlPattern = UrlConstraint$SmartcutsMacros.UrlPattern.fromUrl(url);
  } else {
    throw {
          RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
          _1: originalUrl,
          Error: new Error()
        };
  }
  return {
          originalUrl: originalUrl,
          maybePageUntil: Belt_Option.map(param.paginate, (function (param) {
                  return param.pageUntil;
                })),
          urlPattern: urlPattern,
          smartcutId: param.smartcutId
        };
}

var ParamDescriptor = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  stringify: stringify$3,
  fromAuthoringConfig: fromAuthoringConfig
};

function t_encode$4(v) {
  return Js_dict.fromArray([[
                "maybePageUntil",
                Decco.optionToJson(MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_encode, v.maybePageUntil)
              ]]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var maybePageUntil = Decco.optionFromJson(MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "maybePageUntil"), null));
  if (maybePageUntil.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              maybePageUntil: maybePageUntil._0
            }
          };
  }
  var e = maybePageUntil._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".maybePageUntil" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function stringify$4(param) {
  return "{ maybePageUntil: " + (OptionUtils$SmartcutsMacros.stringify(MultiUrlTriggering__Types$SmartcutsMacros.stringifyPageUntil, param.maybePageUntil) + " }");
}

function fromParamDescriptor(param) {
  return {
          maybePageUntil: param.maybePageUntil
        };
}

function toPlaybackCommandValue(oldCommandValue, param) {
  var maybePageUntil = param.maybePageUntil;
  var match = oldCommandValue.paginate;
  return {
          url: oldCommandValue.url,
          smartcutId: oldCommandValue.smartcutId,
          smartcutName: oldCommandValue.smartcutName,
          paginate: match !== undefined && maybePageUntil !== undefined ? ({
                paginateFn: match.paginateFn,
                pageUntil: maybePageUntil
              }) : undefined,
          topologyResult: oldCommandValue.topologyResult,
          smartcutUrlPattern: oldCommandValue.smartcutUrlPattern,
          maybeRedirectedFromUrlPatterns: oldCommandValue.maybeRedirectedFromUrlPatterns
        };
}

var PlaybackParamValue = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  stringify: stringify$4,
  fromParamDescriptor: fromParamDescriptor,
  toPlaybackCommandValue: toPlaybackCommandValue
};

exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* URLUtils-SmartcutsMacros Not a pure module */
